module.exports = __webpack_public_path__ + "static/logo-aa9e77d2d33a77bc2316a7b722d7aa20.png";